<div class="w3-container">
  <mat-toolbar>
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
      <mat-icon>grass</mat-icon>
    </button>
    <span>BRD</span>
    <span class="example-spacer"></span>
    <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
      <mat-icon>download</mat-icon>
    </button>
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
      <mat-icon>print</mat-icon>
    </button>
    <!-- <div class="row">
          <div class="col-4">
    
          </div>
        </div> -->
  </mat-toolbar>

  <mat-form-field appearance="fill">
    <mat-label>เลือกวันที่</mat-label>
    <input matInput [matDatepicker]="picker" (dateChange)="onDateChange($event)">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

</div>
